import { useEffect, useState } from "react";
import './main.css';
import { useSearchParams } from "react-router-dom";
function CollectMoney() {

    const handlePayment = () => {
        if ( window.Razorpay) {
    
            try {
              let notes_b64 = btoa(JSON.stringify(product.notes));

              const options = {
                key: "rzp_live_JtjGCHjkESNzIZ", // Replace with your Razorpay key
                name: `${product.pay_to}`,
                description: `Payment for ${product.product_title}`,
                amount:  finalPrice*100, // Amount in paise
                currency:product.currency,
                
                handler: function (response) {
                  const BOT_TOKEN = "7755731503:AAE-tgVF31zgXE4cqcMqgFlKv7bsJGrF1-E";
                  const CHAT_ID = '776956029';
          
                  const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
                  
                  let tele_message = `✅ - Payment of __ ${product?.currency}${finalPrice} __ for __ ${product?.product_title} __ from __ https://instagram.com/${product?.notes?.from?.username} __ to insta id - https://instagram.com/${product.pay_to}. META - post_id ${product?.notes?.post_id} comment_id ${product?.notes?.comment_id}`
                  
                  let data = {
                      chat_id: CHAT_ID,
                      text: tele_message
                  };
          
                  

                  fetch(url, {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json'
                      },
                      body: JSON.stringify(data)
                  })
                  .then(response => response.json())
                  .then(data => {
                      console.log('Message sent successfully:', data);
                  })
                  .catch(error => {
                      console.error('Error sending message:', error);
                  });
                  alert("Payment completed. You can close this page.");
                  if (product.redirect_url) {
                      window.location.href = product.redirect_url; // Redirect to the provided URL
                  } else {
                      setTimeout(() => {
                          window.close(); // Close the page after a short delay
                      }, 1000);
                  }
                },
                error: function (response) {
                  alert("Payment Failed, Please try again later!")
                },
                modal: {
                  ondismiss: function () {
                  alert("Payment Cancelled, Please try again!")
                  }
                },
                "notes": { "b64data" : notes_b64},
                theme: {
                  color: "#1677ff",
                },
              };

              // console.log("-=-=-=-btoa(product.notes)", notes_b64)
      
              const razorpayInstance = new window.Razorpay(options);
              razorpayInstance.open();
      
            } catch (error) {
              alert("Error loading Razorpay: " + error.message);
            } finally {
              // setLoading(false);
            }
      
          }
      
          else {
            alert("Please try again later...")
          }
    };

    useEffect(() => {
      const loadCheckoutScript = () => {
        return new Promise((resolve, reject) => {
          if (window.Razorpay) return resolve(true);
    
          const script = document.createElement('script');
          script.src = "https://checkout.razorpay.com/v1/checkout.js";
          script.onload = () => resolve(true);
          script.onerror = () => reject(new Error("Razorpay checkout script failed to load"));
          document.body.appendChild(script);
        });
      };
    
      loadCheckoutScript()
        .then(() => console.log("Razorpay checkout script loaded"))
        .catch((error) => console.error(error));
        
    }, []);
    

    const [searchParams] = useSearchParams();
    const [product, setProduct] = useState({});
    const [finalPrice, setFinalPrice] = useState(null);


    useEffect(() => {
      if(finalPrice == null){
        return
      }
      const loadAffordabilityScript = () => {
        return new Promise((resolve, reject) => {
          if (window.RazorpayAffordabilitySuite) return resolve(true);
    
          const script = document.createElement('script');
          script.src = "https://cdn.razorpay.com/widgets/affordability/affordability.js";
          script.onload = () => resolve(true);
          script.onerror = () => reject(new Error("Razorpay Affordability script failed to load"));
          document.body.appendChild(script);
        });
      };
    
      loadAffordabilityScript()
        .then(() => {
          // console.log("Razorpay Affordability script loaded");
          if (window.RazorpayAffordabilitySuite) {
            // console.log("Initializing Razorpay Affordability Suite...");
            const widgetConfig = {
              key: "rzp_live_JtjGCHjkESNzIZ", // Your Razorpay key
              amount: finalPrice * 100, // Convert to paise
            };
            const rzpAffordabilitySuite = window.RazorpayAffordabilitySuite(widgetConfig);
            rzpAffordabilitySuite.render();
          } else {
            console.error("RazorpayAffordabilitySuite is not available.");
          }
        })
        .catch((error) => console.error(error));
        
        
        const BOT_TOKEN = "7755731503:AAE-tgVF31zgXE4cqcMqgFlKv7bsJGrF1-E";
        const CHAT_ID = '776956029';

        const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
        let tele_message = `👁️ - Payment of __ ${product?.currency}${finalPrice} __ for __ ${product?.product_title} __ from __ https://instagram.com/${product?.notes?.from?.username} __ to insta id - https://instagram.com/${product.pay_to}. META - post_id ${product?.notes?.post_id} comment_id ${product?.notes?.comment_id}`
        let data = {
            chat_id: CHAT_ID,
            text: tele_message
        };


        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
            console.log('Message sent successfully:', data);
        })
        .catch(error => {
            console.error('Error sending message:', error);
        });

    }, [finalPrice]);
    
    useEffect(() => {
        // Get the 'state' parameter from the URL
        const encodedData = searchParams.get("state");

        if (encodedData) {
            try {
                // Decode Base64
                const decodedJson = atob(decodeURIComponent(encodedData));

                // Parse JSON
                const productData = JSON.parse(decodedJson);
                setProduct(productData);

                // Detect if the device is an Apple device
                const isAppleDevice = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);

                // Set the correct price
                setFinalPrice(isAppleDevice ? productData.a_price : productData.o_price);
            } catch (error) {
                console.error("Error decoding product data:", error);
            }
        }
    }, [searchParams]);

    return (
        <div className="mobile-layout-page">
            <div className="core-content">
                <div className="header">
                    <p className="pay-to">You're Paying to</p>
                    <h2>{product.pay_to}</h2>
                </div>
                
                <script async src="//www.instagram.com/embed.js"></script>
                <div className="product-details">

                    <h3>{product.product_title}</h3>
                    <div className="price">
                    <p className="regular-price">{product.currency} {product.r_price}</p>
                    <p className="offer-price">{product.currency} {finalPrice}</p>
                    </div>
                    <p className="product-description">{product.product_description}</p>

                </div>

                <p className="secure-payment">Safe & Secure payment with  AES-128-bit encryption.</p>
                <div onClick={handlePayment} className="purchase-button">
                    <p className="pay-now" >Pay {product.currency} {finalPrice}</p>
                </div>
                <div id="razorpay-affordability-widget"> </div>

                <div className="bottom-fixed">
                    <a href="https://instantdm.com">Powered by  <span>⚡InstantDM</span></a>

                </div>
                <p className="watermark">InstantDM</p>
            </div>
        </div>
    )


}
export default CollectMoney;